import api, { API_PATHS } from "@/api/index";
import { NftUpgradeInfoModel } from "@/api/models/nftUpgradeInfo.model";
import memeVotingContract from "@/contracts/memeVoting";

// The backend that used to serve nftUpgradeInfo/getLeaderboard has been permanently
// decommissioned and has no on-chain equivalent (leaderboard is backend-computed from historical
// transaction volume; NFT upgrade mapping needs a larger dedicated rebuild). Both are expected to
// fail every time, so failures are swallowed silently and a safe fallback is returned.
//
// currentPeriod/periods/addressLastMemeTime/addressVotes, however, turned out to be plain
// argument-free on-chain queries against the meme voting contract (confirmed against the old
// backend's own source), so those are now read directly from chain instead.
export class GeneralClient {
  async nftUpgradeInfo(): Promise<NftUpgradeInfoModel> {
    try {
      const response = await api.get(API_PATHS.NFT_UPGRADE_INFO);

      return response.data;
    } catch (e) {
      return null;
    }
  }

  async getLeaderboard(timeFrame: "all-time" | "weekly" | "previous-week"): Promise<
    {
      address: string;
      egldVolume: number;
    }[]
  > {
    try {
      const response = await api.get(API_PATHS.LEADERBOARD, { timeFrame });

      return response.data;
    } catch (e) {
      return [];
    }
  }

  async currentPeriod(): Promise<number | null> {
    try {
      return await memeVotingContract.currentPeriod();
    } catch (e) {
      return null;
    }
  }

  async addressLastMemeTime(address: string): Promise<number | null> {
    try {
      return await memeVotingContract.addressLastMemeTime(address);
    } catch (e) {
      return null;
    }
  }

  async periods(): Promise<number[]> {
    try {
      return await memeVotingContract.periods();
    } catch (e) {
      return [];
    }
  }

  async addressVotes(address: string): Promise<{ period: number; votes: number } | null> {
    try {
      return await memeVotingContract.addressVotes(address);
    } catch (e) {
      return null;
    }
  }
}

const generalClient = new GeneralClient();

export default generalClient;
